<script>
export default {
    name: 'IlluPaiement',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-paiement"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <circle
                :stroke="secondaryColor"
                class="secondary-color"
                cx="39"
                cy="32"
                r="15.5"
            />
            <path
                d="M39.969 40c1.27 0 2.418-.236 3.445-.707A6.855 6.855 0 0046 37.238l-2.157-2.122c-1.005 1.223-2.24 1.834-3.707 1.834-.921 0-1.745-.22-2.471-.663a4.411 4.411 0 01-1.675-1.834h5.298v-1.856h-5.822a6.215 6.215 0 01-.021-.597l.001-.186c.003-.174.01-.311.02-.41h5.822v-1.857H35.99c.39-.78.949-1.392 1.675-1.834.726-.442 1.55-.663 2.471-.663 1.452 0 2.688.604 3.707 1.812L46 26.74a6.944 6.944 0 00-2.586-2.033c-1.027-.471-2.175-.707-3.445-.707-1.215 0-2.342.228-3.383.685a7.37 7.37 0 00-2.649 1.945 7.677 7.677 0 00-1.57 2.917H30v1.856h2.052c-.014.133-.02.332-.02.597v.186c.003.174.01.311.02.41H30v1.857h2.366a7.677 7.677 0 001.571 2.917 7.37 7.37 0 002.65 1.945c1.04.457 2.167.685 3.382.685z"
                :fill="primaryColor"
                class="primary-color"
            />
            <path
                :stroke="secondaryColor"
                class="secondary-color"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M11 32h10M16 24h6M9 40h10"
            />
        </g>
    </svg>
</template>
